import React from 'react'
import { Auth } from 'aws-amplify';

export const TMC = () => {
  return (
    <h1>TMC</h1>
  )
}
